module.exports = __webpack_public_path__ + "static/media/meeting.4066d212.svg";